<lv-uiartefakt-container [uiArtefakte]="beitragBoxData$ | async"></lv-uiartefakt-container>

